/**
 * UI-only user-to-role assignments.
 *
 * Add application users here. Never add passwords, tokens, or client secrets.
 * Backend APIs must independently validate the Keycloak token and permissions.
 */
export interface User {
  Role: string;
  Email: string;
  WWID: string;
}

export const users: User[] = [
  
  {
    Role: 'full_view',
    Email: 'neeraj.bhargava@simadvisorytech.com',
    WWID: 'ak26l@cummins.com',
  },
   {
    Role: 'full_view',
    Email: 'juliet.gabriel@cummins.com',
    WWID: 'bd10u@cummins.com',
  },
  {
    Role: 'full_view',
    Email: 'sneha.gupta@simadvisorytech.com',
    WWID: 'user-id@example.com',
  },
  {
    Role: 'full_view',
    Email: 'juliet.gabriel@simadvisorytech.com',
    WWID: 'user-id@example.com',
  },
  {
    Role: 'full_view',
    Email: 'aditya.b@simadvisorytech.com',
    WWID: 'user-id@example.com',
  },
  {
    Role: 'full_view',
    Email: 'tanvi.chaudhari@cummins.com',
    WWID: 'aw65v@cummins.com',
  },{
  
    Role: 'dashboard_admin',
    Email: '',
    WWID: 'pi796@cummins.com',
  },
  {
    Role: 'full_view',
    Email: 'chetan.rc@simadvisorytech.com',
    WWID: 'chetan.rc@simadvisorytech.com',
  },
  {
    Role: 'full_view',
    Email: '',
    WWID: 'cg975@cummins.com',
  },
  {
    Role: 'full_view',
    Email: 'abhinav.comrade@simadvisorytech.com',
    WWID: 'abhinav.comrade@simadvisorytech.com',
  },
  {
    Role: 'full_view',
    Email: 'rupak.tibrewal@simadvisory.com',
    WWID: 'rupak.tibrewal@simadvisory.com',
  },
   {
    Role: 'full_view',
    Email: 'user_admin',
    WWID: 'user_admin',
  },
   {
    Role: 'full_view',
    Email: 'user_test',
    WWID: 'user_test',
  }
  
];

function normalizedIdentity(value: unknown): string {
  return typeof value === 'string' ? value.trim().toLocaleLowerCase() : '';
}

/** Resolve an application role by email, WWID, or username. */
export function getMappedRoleForUser(
  email?: string | null,
  wwidOrUsername?: string | null,
): string | null {
  const identities = [email, wwidOrUsername]
    .map(normalizedIdentity)
    .filter((value) => value.length > 0);

  if (!identities.length) return null;

  const match = users.find((user) => {
    const mappedEmail = normalizedIdentity(user.Email);
    const mappedWwid = normalizedIdentity(user.WWID);
    return identities.some((identity) =>
      (mappedEmail.length > 0 && identity === mappedEmail)
      || (mappedWwid.length > 0 && identity === mappedWwid));
  });

  const role = match?.Role?.trim();
  return role || null;
}
